import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { range } from "lodash";
import { FC, MutableRefObject } from "react";

const borderColor = "rgba(0,0,0,0.1)";

const Column = styled.div`
  position: relative;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;
const TimeSlot = styled(motion.div)`
  flex: 1;
  border-left: 1px solid ${borderColor};
  & + & {
    border-top: 1px dashed ${borderColor};
  }
`;

type TimeSlotColumnsProps = {
  daysToDisplay: number;
  backgroundColors?: string[][];
  columnRefs: MutableRefObject<HTMLDivElement | null>[];
  cellRef: MutableRefObject<HTMLDivElement | null>;
  onEmptyTimeSlotClick: (column: number, hour: number) => void;
};
export const TimeSlotColumns: FC<TimeSlotColumnsProps> = ({
  daysToDisplay,
  backgroundColors,
  columnRefs,
  cellRef,
  onEmptyTimeSlotClick,
}) => {
  return (
    <>
      {range(daysToDisplay).map((column) => (
        <Column ref={columnRefs[column]} key={column}>
          {range(24).map((hour) => {
            const animationProps = {
              backgroundColor:
                backgroundColors?.[column]?.[hour] || "hsl(60, 100%, 100%)",
            };
            return (
              <TimeSlot
                key={hour}
                ref={column === 0 && hour === 0 ? cellRef : undefined}
                onClick={() => {
                  onEmptyTimeSlotClick(column, hour);
                }}
                initial={animationProps}
                animate={animationProps}
              />
            );
          })}
        </Column>
      ))}
    </>
  );
};
